module.exports = {"id":"209989","name":"Thomas Partey","rating":"80","photo":"./data/images/photos/4/209989.png","club":{"name":"Atlético Madrid","logo":"./data/images/clubs/AtleticoMadrid.png"},"positions":["MDC","MC","MD","DD"],"photoFolderIndex":4}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/ThomasPartey0.json
// module id = 4114
// module chunks = 0